var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"value":_vm.value.text,"readonly":"","label":_vm.$t('Antwort'),"hint":_vm.computedHint,"persistent-hint":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }